export const GET_SPECIALIZATION = 'GET_SPECIALIZATION';
export const LOADING_SPECIALIZATION = 'LOADING_SPECIALIZATION';
export const SAVE_LOADER_SPECIALIZATION = 'SAVE_LOADER_SPECIALIZATION';
export const FORM_FAIL = "FORM_FAIL";
export const SPECIALIZATION_FAIL = 'SPECIALIZATION_FAIL';
